export const formatHelper = {
    formatFileSize: function (bytes) {
	if (typeof bytes !== 'number') {
            return '';
	}
	if (bytes >= 1000000000) {
            return (bytes / 1000000000).toFixed(2) + ' GB';
	}
	if (bytes >= 1000000) {
            return (bytes / 1000000).toFixed(2) + ' MB';
	}
	return (bytes / 1000).toFixed(2) + ' KB';
    },
    formatBitrate: function (bits) {
	if (typeof bits !== 'number') {
            return '';
	}
	if (bits >= 1000000000) {
            return (bits / 1000000000).toFixed(2) + ' Gbit/s';
	}
	if (bits >= 1000000) {
            return (bits / 1000000).toFixed(2) + ' Mbit/s';
	}
	if (bits >= 1000) {
            return (bits / 1000).toFixed(2) + ' kbit/s';
	}
	return bits.toFixed(2) + ' bit/s';
    },

    formatTime: function (seconds) {
	var date = new Date(seconds * 1000),
            days = Math.floor(seconds / 86400);
	days = days ? days + 'd ' : '';
	return days +
            ('0' + date.getUTCHours()).slice(-2) + ':' +
            ('0' + date.getUTCMinutes()).slice(-2) + ':' +
            ('0' + date.getUTCSeconds()).slice(-2);
    },

    formatPercentage: function (floatValue) {
	return (floatValue * 100).toFixed(2) + ' %';
    },

    renderTransferProgress: function (bitrate, total, loaded ) {
	var white_space = ' &nbsp; | &nbsp; ';
	return this.formatBitrate(bitrate) + white_space  +
            this.formatPercentage(
		loaded / total
            ) + white_space +
            this.formatFileSize(loaded) + ' / ' +
            this.formatFileSize(total)  + white_space + 
	    'Time remaining: ' + this.formatTime((total - loaded) * 8 / bitrate );
    }
};
